/**
 * FH-A11Y batch 16 (2026-09-26): price filter keyboard trap.
 * The older script (ada-a11y-fixes.js, "Globo price keyboard focus" block) remembered the price
 * slider and, whenever the filter panel changed, pulled focus back to it, even after Tab had moved
 * on to the next filter. Each Tab bounced back, so keyboard users were stuck on the slider.
 * This file loads before that (deferred) script and switches that block off. Batch 15 already puts
 * focus back on a slider handle after filtering; this adds the same for the Min / Max price boxes.
 * Rollback: remove the ada-a11y-batch16.js line at the end of snippets/freshdesk.liquid.
 */
(function () {
  'use strict';
  if (window.__fhA11yBatch16) return;
  window.__fhA11yBatch16 = true;

  /* Makes the older script's bindGloboPriceKeyboardFocus() return straight away. */
  window.__adaGloboPriceKbdBound = true;

  var BOX = '.gf-range-inputs input';
  var restore = null; /* { id, until } */

  function remember(t) { restore = { id: t.id, until: Date.now() + 15000 }; }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.id && t.matches && t.matches(BOX)) remember(t);
  }, true);
  document.addEventListener('keydown', function (e) {
    var t = e.target;
    if (e.key === 'Enter' && t && t.id && t.matches && t.matches(BOX)) remember(t);
  }, true);
  /* Moving on to any other control, or clicking, ends it. */
  document.addEventListener('focusin', function (e) {
    var t = e.target;
    if (restore && t && t.id !== restore.id && t.tabIndex >= 0) restore = null;
  }, true);
  document.addEventListener('pointerdown', function () { restore = null; lastOpt = null; }, true);

  /* Other filter options (e.g. Brand, Color): if the panel is rebuilt while one of them has focus
     (for example after Tab applies a price change), focus the same option in the new panel instead
     of dropping back to the top of the page. */
  var lastOpt = null; /* { el, key } */
  document.addEventListener('focusin', function (e) {
    var t = e.target;
    var key = t && t.getAttribute && t.getAttribute('data-fh-gf-key');
    lastOpt = key ? { el: t, key: key, until: Date.now() + 15000 } : null;
  }, true);
  function checkOption() {
    if (!lastOpt) return;
    if (Date.now() > lastOpt.until) { lastOpt = null; return; }
    if (lastOpt.el.isConnected) return;
    var a = document.activeElement;
    if (a && a !== document.body && a !== document.documentElement && a.isConnected) { lastOpt = null; return; }
    var list = document.querySelectorAll('[data-fh-gf-key]');
    for (var i = 0; i < list.length; i++) {
      if (list[i].getAttribute('data-fh-gf-key') === lastOpt.key && list[i].getClientRects().length) {
        try { list[i].focus({ preventScroll: true }); } catch (err) { list[i].focus(); }
        return;
      }
    }
  }

  function check() {
    try { checkOption(); } catch (err) {}
    if (!restore) return;
    if (Date.now() > restore.until) { restore = null; return; }
    var a = document.activeElement;
    if (a && a !== document.body && a !== document.documentElement && a.isConnected) {
      if (a.id !== restore.id) restore = null;
      else restore.until = Math.max(restore.until, Date.now() + 5000);
      return;
    }
    var el = document.getElementById(restore.id);
    if (el && el.getClientRects().length) {
      try { el.focus({ preventScroll: true }); } catch (err) { el.focus(); }
    }
  }

  function start() {
    new MutationObserver(check).observe(document.documentElement, { childList: true, subtree: true });
    setInterval(check, 250);
  }
  if (document.documentElement) start();
  else document.addEventListener('DOMContentLoaded', start);
})();
